module.exports = __webpack_public_path__ + "img/right-double.3d2753f3.svg";